/**
 * Daily Checks Helper
 * Evaluates daily check requirements based on vessel configuration
 */

/**
 * Determines if daily checks are required for this vessel
 * Per regulations: Only inland passenger vessels require daily checks
 */
export function isDailyChecksRequired(ctx) {
  const { vessel } = ctx;
  
  // Daily checks are required for inland waterway passenger vessels
  const isInlandWaterway = vessel.operatingStatus === 'inland';
  const carriesPassengers = vessel.hasPassengers === true || 
                           vessel.type === 'pax' || 
                           vessel.type === 'passenger';
  
  return isInlandWaterway && carriesPassengers;
}

/**
 * Get the storage key for daily checks
 * Format: daily_checks_${vesselId}_${date}
 */
export function getDailyChecksKey(vesselId, date) {
  // Normalize date to YYYY-MM-DD format
  const normalizedDate = new Date(date).toISOString().split('T')[0];
  return `daily_checks_${vesselId}_${normalizedDate}`;
}

/**
 * Generate daily check requirement
 */
export function generateDailyCheckRequirement(ctx) {
  if (!isDailyChecksRequired(ctx)) {
    return null;
  }

  return {
    id: 'daily_checks_inland_passenger',
    module: 'operations',
    name: 'Daily Safety Checks',
    description: 'Daily safety checks required for inland waterway passenger vessels',
    required: true,
    status: 'required',
    citation: 'INLAND/DC Section 1',
    frequency: 'daily',
    checkType: 'safety',
    applicableVesselTypes: ['pax', 'passenger'],
    conditions: [
      'Operating on inland waterways',
      'Carrying passengers'
    ],
    metadata: {
      storageKeyPattern: 'daily_checks_${vesselId}_${date}',
      independentOfVoyage: true
    }
  };
}